import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const SuccessUI = () => (
  <React.Fragment>
    <h2 className="mb-4 font-weight-bold">Password Reset Successful!</h2>
    <b>Your new password has been successfully saved. You can now login using your new password. </b>
    <Link to={ROUTES.LOGIN} className="w-100">
      <button className="wf-submit smaller">Log in</button>
    </Link>
  </React.Fragment>
);

export default SuccessUI;
